import {
  GET_WALL_RECORD_COUNTS,
  GET_TRUE_SENSE_RECOMMENDATION,
  GET_POST_LANGUAGE,
  GET_TOP_AI_TAGS, 
  GET_EVENT_VOICE,
  GET_LEADER_BOARD,
  GET_SENTIMENTS_DATA,
  GET_SENTIMENT_STATISTICS,
  GET_SENTIMENT_LIVE_TREND,
  GET_CONTENT_ANALYTICS,
  GET_WORD_CLOUD,
  GET_POST_TYPE_COUNT, 
  GET_WIDGET_ANALYTICS, 
  GET_PERFORMING_POST_DATA,
  GET_HIGHEST_POST_SHARED,
  GET_FLAGES,
  GET_ASSETS_NETWORK,
  SENTIMENT_LOADER,
  LEADER_BOARD_LOADER,
  TOP_EVENT_LOADER,
  TRUSENSE_LOADER,
  WORD_LOADER,
  TOP_AI_LOADER,
  POST_TYPE_COUNT_LOADER,
  POST_BY_LANGUAGE_LOADER,
  POSTS_BY_NETWORK_LOADER,
  CONTENT_LOADER,
  GET_SCREEN_ANALYTICS_DATA,
  GET_SCREEN_ANALYTICS_LOADER, 
  GET_PERFORMING_POST_LOADER, 
  GET_ALL_WEB_DATA,
  GET_ALL_WEB_DATA_LOADER, 
  GET_SCREEN_OVERVIEW_DATA,
  GET_SCREEN_OVERVIEW_DATA_LOADER,
  GET_TOP_REACTED_POSTS_DATA,
  GET_TOP_REACTED_POSTS_DATA_LOADER,
  GET_WEB_POST_OVERVIEW_DATA,
  GET_WEB_POST_OVERVIEW_LOADER,
  GET_WEB_ANALYTIC_DATA,
  GET_WEB_ANALYTIC_LOADER,
  ACTIVE_TAB,
  PAGE_REFRESH,
  GET_WALL_SENTIMENT_LIVE_TREND_DATA,
  GET_WALL_SENTIMENT_LIVE_TREND_LOADER,
  ANALYTICS_STATUS_LOADER,
  UPDATE_SELECTED_FEED_DATA,
  UPDATE_FILTER_DATE
} from "../keys";
import moment from "moment";

const initialState = {
  analytics_status_loader: false,   
  page_refresh : false,  
  activeTab : 1, 
  content_loader : false,
  sentiment_loader : false,
  leader_board_loader : false,
  top_event_loader : false,
  trusense_loader : false,
  word_loader : false,
  top_ai_loader : false,
  post_type_count_loader : false,  
  post_by_language_loader : false,  
  posts_by_network_loader : false, 
  get_dis : false, 
  get_screen_analytics_loader : false, 
  get_performing_post_loader : false,
  get_reacted_posts_loader : false,
  get_all_web_data_loader: false,
  get_screen_overview_data_loader: false,
  get_post_overview_loader : false,
  get_web_analytic_loader : false,
  get_wall_sentiment_live_trend_loader : false,

//   get_wall_sentiment_live_trend_data:
//   {
//     "name": "Sentiment Live Trend",
//     "labels": [
//         "19/09/2024 01:30",
//         "19/09/2024 02:30",
//         "19/09/2024 03:30",
//         "19/09/2024 04:30",
//         "19/09/2024 05:30",
//         "19/09/2024 06:30",
//         "19/09/2024 07:30",
//         "19/09/2024 08:30",
//         "19/09/2024 09:30",
//         "19/09/2024 10:30",
//         "19/09/2024 11:30",
//         "19/09/2024 12:30",
//         "19/09/2024 13:30",
//         "19/09/2024 14:30",
//         "19/09/2024 15:30",
//         "19/09/2024 16:30",
//         "19/09/2024 17:30",
//         "19/09/2024 18:30",
//         "19/09/2024 19:30",
//         "19/09/2024 20:30",
//         "19/09/2024 21:30",
//         "19/09/2024 22:30"
//     ],
//     "data": [
//         12,
//         78,
//         78,
//         42,
//         66,
//         0,
//         45,
//         47,
//         74,
//         1,
//         0,
//         5,
//         12,
//         54,
//         65,
//         74,
//         78,
//         22,
//         8,
//         25,
//         35,
//         40
//     ]
// },


get_wall_sentiment_live_trend_data:
{
  "name": "Sentiment Live Trend",
  "labels": [],
  "data": []
},
 
  selected_feed_data: [],
  get_web_analytic_data: [],
  get_all_web_data : [],
  get_screen_analytics_data : [],
  get_screen_overview:[],
  get_screen_overview_data:[],
  get_performing_post_data : [],
  get_post_overview_data:[
    {
        "name": "Widget Views",
        "count": "0",
        "description": "Total number of visitors who viewed the widget."
    },
    {
        "name": "Popup Clicks",
        "count": "6",
        "description": "Total number of times a popup was clicked."
    },
    {
        "name": "Show More Click",
        "count": "8",
        "description": "Number of times the 'Show More' button was clicked."
    },
    {
        "name": "CTA Click",
        "count": "0",
        "description": "Total number of CTA (Call to Action) clicks."
    }
],
  get_top_reacted_posts : [],
  getFlags:[],  userfeeds: [], selectedWallFeed: [], dateFilter: { startDate: moment().subtract(29, 'days').startOf('day'), endDate: moment().endOf('day') }, selectedFeed: [],postType:[{ value: "1", label: "Public" }, { value: "2", label: "Private" }], loading:true,
  contentCount: [
    {
        "label": "Total Posts",
        "tool_tip": "The accurate number of posts added to your Social Wall.",
        "total": 0
    },
    {
        "label": "Total Feed",
        "tool_tip": "The overall interactions with your Galleries.",
        "total": 0
    },
    {
        "label": "Average Recommendation Score",
        "tool_tip": "The accurate number of Public posts displayed on your Social Wall.",
        "total": 9
    }
],

  contentAnalytics:  [
    {
        "name": "Total Posts",
        "labels": [],
        "data": [],
        "tool_tip": "The accurate number of posts added to your Social Wall.",
        "count": 0,
        "difference": ""
    },
    {
        "name": "Total Feeds",
        "labels": [],
        "data": [],
        "tool_tip": "",
        "count": 0,
        "difference": ""
    },
    {
        "name": "Total Recommendended",
        "labels": [],
        "data": [],
        "tool_tip": "",
        "count": "0%",
        "difference": "0%"
    }
],
  sentimentliveTrend: [],
  sentimentStatistics: {
    "Strongly Positive": 5,
    "Positive": 4,
    "Neutral": 2,
    "Negative": 0,
    "Strongly Negative": 0
},

  sentimentPost:  
  [
    {
        "name": "Sentiment Statistics",
        "data": [
            {
                "Strongly Positive": 0,
                "Positive": 0,
                "Neutral": 0,
                "Negative": 0,
                "Strongly Negative": 0
            }
        ]
    },
    {
        "name": "Sentiment Posts",
        "positive": [],
        "negative": []
    },
    {
        "name": "Sentiment Live Trend",
        "labels": [],
        "data": []
    }
]
,
  leaderBoard: {
    "data": [],
    "total": 0
},
  topeventVoices: {
    "data": [],
    "total": 0
},
  truSense: [{
    "name": "Recommended",
    "details": "Perfect for your campaign! This visual aligns with your brand and goals.",
    "total": 0,
  },
  {
    "label": "Considerable",
    "details": "Take a closer look! This visual might work with some adjustments.",
    "total": 0,
  },
  {
    "name": "Not Recommended",
    "details": "Hold off for now. This visual might not be the best fit for your current campaign.",
    "total": 0,
  }],
  wordCloud: [],
  postTypeCount:  [
    {
        "name": "Post Type",
        "labels": [
            "Image Posts",
            "Video Posts",
            "Text Posts"
        ],
        "data": [
            0,
            0,
            0
        ],
        "total": 0
    }
],
  postbyLanguage: [],
  postbyNetwork: [],
  topaiTags:  [], 
  postOverview: {},   
 
};

export default function reducer(state = initialState, action) {
    
    switch (action.type) {
 
        case ACTIVE_TAB:{
             const activetab = action.payload.includes('widget') ? 2 : action.payload.includes('display') ? 3 : 1
             return { ...state, activeTab: activetab,  dateFilter: { startDate: moment().subtract(29, 'days').startOf('day'), endDate: moment().endOf('day') } } 
        }
        case ANALYTICS_STATUS_LOADER:{
            return { ...state, analytics_status_loader : action.payload }
        }
        case PAGE_REFRESH:{
            return { ...state, page_refresh : action.payload }
        }
        case GET_WALL_RECORD_COUNTS: {
            return { ...state, contentCount: action.payload }
        }
        case GET_TRUE_SENSE_RECOMMENDATION:{ 
            return { ...state, truSense: action.payload, trusense_loader: false }
        }
        case GET_POST_LANGUAGE:{
            return { ...state, postbyLanguage: action.payload, post_by_language_loader : false  }
        }
        case GET_TOP_AI_TAGS:{
            return { ...state, topaiTags: action.payload, top_ai_loader : false }
        }
        case GET_ASSETS_NETWORK:{
            return { ...state, postbyNetwork: action.payload, posts_by_network_loader : false }
        }
        case GET_EVENT_VOICE:{
           return { ...state, topeventVoices: action.payload, top_event_loader : false }
        }
        case GET_SENTIMENTS_DATA:{
            return { ...state, sentimentPost: action.payload, sentiment_loader : false }
        }
        case GET_LEADER_BOARD:{
            return { ...state, leaderBoard: action.payload, leader_board_loader : false }
        }
        case GET_SENTIMENT_STATISTICS:{
            return { ...state, sentimentStatistics: action.payload }
        }
        case GET_SENTIMENT_LIVE_TREND:{
           // return { ...state, topaiTags: action.payload }
        }
        case GET_CONTENT_ANALYTICS:{
            return { ...state, contentAnalytics: action.payload, content_loader : false }
        }
        case GET_WORD_CLOUD:{
            return { ...state, wordCloud: action.payload, word_loader : false }
        }
        case GET_POST_TYPE_COUNT:{
            return { ...state, postTypeCount: action.payload, post_type_count_loader: false }
        }         
        case GET_WIDGET_ANALYTICS:{
          //  return { ...state, topaiTags: action.payload }
        }
         case GET_HIGHEST_POST_SHARED:{
           // return { ...state, topaiTags: action.payload }
        }
        case GET_FLAGES:{
            return { ...state, getFlags: action.payload }
        }
        case CONTENT_LOADER:{
            return { ...state, content_loader: action.payload }
        }
        case SENTIMENT_LOADER:{
            return { ...state, sentiment_loader: action.payload }
        }
        case LEADER_BOARD_LOADER:{
            return { ...state, leader_board_loader: action.payload }
        }
        case TOP_EVENT_LOADER:{
            return { ...state, top_event_loader: action.payload }
        }
        case TRUSENSE_LOADER:{
            return { ...state, trusense_loader: action.payload }
        }
        case WORD_LOADER:{
            return { ...state, word_loader: action.payload }
        }
        case TOP_AI_LOADER:{
            return { ...state, top_ai_loader: action.payload }
        }
        case POST_TYPE_COUNT_LOADER:{
            return { ...state, post_type_count_loader: action.payload }
        }
        case POST_BY_LANGUAGE_LOADER:{
            return { ...state, post_by_language_loader: action.payload }
        }
        case POSTS_BY_NETWORK_LOADER:{
            return { ...state, posts_by_network_loader: action.payload }
        }
        case GET_SCREEN_ANALYTICS_DATA:{
            return { ...state, get_screen_analytics_data: action.payload, get_screen_analytics_loader : false }
        }
        case GET_SCREEN_ANALYTICS_LOADER:{
            return { ...state, get_screen_analytics_loader: action.payload }
        }
        case GET_SCREEN_OVERVIEW_DATA:{
            return { ...state, get_screen_overview_data: action.payload, get_screen_overview_data_loader : false }
        }
        case GET_SCREEN_OVERVIEW_DATA_LOADER:{
            return { ...state, get_screen_overview_data_loader: action.payload }
        }
        case GET_PERFORMING_POST_DATA:{
            return { ...state, get_performing_post_data: action.payload, get_performing_post_loader : false }
        }
        case GET_PERFORMING_POST_LOADER:{
            return { ...state, get_performing_post_loader: action.payload }
        }
        case GET_WEB_ANALYTIC_DATA:{
            return { ...state, get_web_analytic_data: action.payload, get_web_analytic_loader : false }
        }
        case GET_WEB_ANALYTIC_LOADER:{
            return { ...state, get_web_analytic_loader: action.payload }
        }
        case GET_WEB_POST_OVERVIEW_DATA:{
            return { ...state, get_post_overview_data: action.payload, get_post_overview_loader : false }
        }
        case GET_WEB_POST_OVERVIEW_LOADER:{
            return { ...state, get_post_overview_loader: action.payload }
        }
        case GET_TOP_REACTED_POSTS_DATA:{
             return { ...state, get_top_reacted_posts: action.payload, get_reacted_posts_loader : false }
         } 
         case GET_TOP_REACTED_POSTS_DATA_LOADER:{
             return { ...state, get_reacted_posts_loader: action.payload }
         }     
          
        case GET_ALL_WEB_DATA:{
            return { ...state, get_all_web_data: action.payload, get_all_web_data_loader : false }
        } 
        case GET_ALL_WEB_DATA_LOADER:{
            return { ...state, get_all_web_data_loader: action.payload }
        }       

        case GET_WALL_SENTIMENT_LIVE_TREND_DATA:{
            return { ...state, get_wall_sentiment_live_trend_data: action.payload, get_wall_sentiment_live_trend_loader : false }
        } 
        case GET_WALL_SENTIMENT_LIVE_TREND_LOADER:{
            return { ...state, get_wall_sentiment_live_trend_loader: action.payload }
        }     
        case UPDATE_SELECTED_FEED_DATA:{
            return { ...state, selected_feed_data: action.payload }
        }  
        
        case UPDATE_FILTER_DATE:{
            return { ...state, dateFilter: { startDate: action.payload.startDate, endDate : action.payload.endDate }}
        }  
        
         default:
            return { ...state }
    }

}
